import parse from "url-parse";

/**
 * Resource timing configuration for Trello UFO
 * Filters and sanitizes resource URLs before UFO captures them
 */

// Sanitize endpoints: replace UUIDs and IDs with placeholders
const sanitiseEndpoints = (url: string): string | null => {
    try {
        const parsedUrl = parse(url, true);
        const fileName = parsedUrl.pathname
            .replace(
                /[a-zA-Z0-9]{8}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{12}/gi,
                "<uuid>"
            )
            .replace(/\/\d+$/i, "/<id>");

        return fileName || null;
    } catch {
        return null;
    }
};

// Map resource names for better readability
const mapResources = (url: string): string | null => {
    try {
        if (url.includes("/gasv3/")) return "gasv3";
        if (url.includes("/analytics/")) return "analytics";
        if (url.includes("bifrost")) return "bifrost-assets";
        if (url.includes("stargate")) return "stargate-graphql";
        if (url.includes("atl-global")) return "atl-global";
        return sanitiseEndpoints(url);
    } catch {
        return null;
    }
};

// Check if resource has timing headers
const hasTimingHeaders = (url: string): boolean => {
    // Track analytics, API calls, assets
    if (
        url.includes("/gasv3/") ||
        url.includes("/analytics/") ||
        url.includes("bifrost") ||
        url.includes("stargate")
    ) {
        return true;
    }
    return false;
};

// Filter XHR traffic
const xhrFilter = (url: string): boolean => {
    // Track analytics, API calls, assets
    if (
        url.includes("/gasv3/") ||
        url.includes("/analytics/") ||
        url.includes("bifrost") ||
        url.includes("stargate")
    ) {
        return true;
    }
    return false;
};

export function getResourceTimingsConfig() {
    return {
        sanitiseEndpoints,
        mapResources,
        hasTimingHeaders,
        xhrFilter
    };
}
